import React from 'react'

const NumberOption = ({number}) => {
  return (
    <div className="number-options">{number}</div> 
  )
}

export default NumberOption
